import { combineReducers } from "redux";
import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import notificationsReducer from "./notifications";
import alertsReducer from "./alerts";
import capturesReducer from "./captures";
import devicesReducer from "./devicesSlice";
import organizationsReducer from "./organizations";
import schedulesReducer from "./schedules";
import analyticsReducer from "./analytics";
import commandReducer from "./command";
import alertsSlice from "./alertsSlice";
import catalogFilterReducer from "./catalogFilterSlice";
import catalogSelectionReducer from "./catalogSelectionSlice";
import catalogItemsReducer from "./catalogItemsSlice";
import {
  catalogApi,
  captureApi,
  alertApi,
  trapSiteApi,
  deviceApi,
  detectionApi,
} from "../actions";

const reducers = combineReducers({
  [deviceApi.reducerPath]: deviceApi.reducer,
  [trapSiteApi.reducerPath]: trapSiteApi.reducer,
  [alertApi.reducerPath]: alertApi.reducer,
  [catalogApi.reducerPath]: catalogApi.reducer,
  [captureApi.reducerPath]: captureApi.reducer,
  [detectionApi.reducerPath]: detectionApi.reducer,
  notifications: notificationsReducer,
  alerts: alertsReducer,
  captures: capturesReducer,
  devices: devicesReducer,
  organizations: organizationsReducer,
  schedules: schedulesReducer,
  analytics: analyticsReducer,
  command: commandReducer,
  alertsSlice: alertsSlice,
  catalogFilter: catalogFilterReducer,
  catalogSelection: catalogSelectionReducer,
  catalogItems: catalogItemsReducer,
});

export const store = configureStore({
  reducer: reducers,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(deviceApi.middleware)
      .concat(trapSiteApi.middleware)
      .concat(alertApi.middleware)
      .concat(catalogApi.middleware)
      .concat(captureApi.middleware)
      .concat(detectionApi.middleware),
  devTools:
    process.env.REACT_APP_ENV !== "production"
      ? {
          trace: true,
          traceLimit: 25,
        }
      : false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
